import React from 'react';
const TOUR_URL = 'https://laylo.com/lennoncripe/m/kwIGjg';
interface TourPopupLinkProps {
  className?: string;
}
export function TourPopupLink({
  className = 'lowercase hover:opacity-60'
}: TourPopupLinkProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    const popupWidth = Math.min(960, window.screen.availWidth);
    const popupHeight = Math.min(760, window.screen.availHeight);
    const left = Math.max(0, Math.round(window.screenX + (window.outerWidth - popupWidth) / 2));
    const top = Math.max(0, Math.round(window.screenY + (window.outerHeight - popupHeight) / 2));
    const popup = window.open(TOUR_URL, 'lennon-cripe-tour', `popup=yes,width=${popupWidth},height=${popupHeight},left=${left},top=${top},noopener,noreferrer`);
    if (popup) {
      popup.focus();
      return;
    }
    window.open(TOUR_URL, '_blank', 'noopener,noreferrer');
  };
  return <a href={TOUR_URL} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={className} aria-label="Open tour dates and RSVP" data-id="element-196" data-mp="rc5j0xvl5a78">
      tour
    </a>;
}